<template>
  <div class="home page">
    <c-header :left-arrow="false" title="首页">
      <!-- <template #right v-if="data.code">
                <span class="color-primary" @click="goHome">返回首页</span>
</template>-->
      </c-header>
      <!-- 轮播图-->
      <div class="padding-30" v-if="data.bannerList.length > 0">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(img,index) in data.bannerList" :key="index">
                  <div class="swiper-img">
                      <img :src="img.addetails" alt="" style="width:100%;height:100%;">
                  </div>
              </van-swipe-item>
          </van-swipe>
      </div>
      <!--功能按钮区-->
      <div class="fun-btn bg-white flex-row-between border-radius-16" v-if="data.js_code || data.isShow">
          <div class="fun-item flex-column"
               v-for="(item,index) in data.funList"
               :key="index" @click="onFunction(item,item.text)">
              <div class="margin-bottom-10">
                  <img :src="item.img" alt="" style="width:100%;height:100%;">
              </div>
              <span class="font-size-24">{{item.text}}</span>
          </div>
      </div>
      <!--广告-->
      <div class="advertising padding-30" v-if="data.js_code || data.isShow">
          <div class="ad-img border-radius-16">
              <img :src="data.adDetail.addetails" alt="" style="width:100%;height:100%;">
          </div>
      </div>
      <!--商品详情-->
      <div class="flex-row bg-white padding-30" v-if="data.detail.pname && data.code">
          <div class="border-radius-10 margin-right-10 avtor-img">
              <img :src="data.detail.proavtor" alt="" style="width:100%;height:100%;">
          </div>
          <div class="product-content flex-column-around">
              <div class="font-weight">{{data.detail.pname}}</div>
              <div class="color-666 font-size-24">{{data.detail.ptype}}</div>
              <div class="color-666 font-size-24" v-if="data.detail.salesprice">全国统一零售价：<span class="font-size-32 color-err">￥{{data.detail.salesprice}}</span></div>
          </div>
      </div>
      <div class="flex-row font-size-22 bg-white padding-0-30-30-30" v-if="data.detail.pname && data.code && data.detail.salestatus !== '未激活'">
          <div class="border-color-err padding-4-8 border-radius-18 margin-right-10 color-err">
              开启保修时间：{{getTime(data.detail.activedate)}}
          </div>
          <div class="border-color-err padding-4-8 border-radius-18 color-err" v-if="returnTime(data.detail.servendtime) > 0">保修结束时间：{{getTime(data.detail.servendtime)}}</div>
          <div class="border-color-err padding-4-8 border-radius-18 color-err" v-else>过保：{{Math.abs(Math.ceil(returnTime(data.detail.servendtime)))}}天</div>
      </div>
      <!--登录按钮-->
      <!--<div class="padding-15 flex-center" v-if="data.code && data.detail.salestatus === '未激活'">
          <div class="login-btn" @click="toDealer">经销商登录</div>
      </div>-->
      <div class="service-btn bg-primary top-290"
           v-if="data.code && data.detail.salestatus === '未激活'"
           @click="toDealer()">
          经销商登录
      </div>
      <div class="service-btn bg-primary" style="margin-top: 100px;"
           v-if="data.showCustomerBtn == true"
           @click="toCustomer()">
          客服
      </div>
      <!--产品说明书-->
      <div class="block bg-white padding-15 margin-bottom-10" v-if="data.detail.pname && data.code">
          <div class="margin-bottom-10">产品说明书</div>
          <div class="flex-column padding-15">
              <div class="detail-video margin-30 border-radius-10" v-if="data.detail.manulvideo">
                  <video :src="data.detail.manulvideo"
                         preload="true"
                         webkit-playsinline="true"
                         x5-video-player-type="h5"
                         x5-video-orientation="portraint"
                         style="width: 100%;height:100%;"
                         controls/>
              </div>
              <div class="detail-img margin-bottom-10 border-radius-10" v-for="(item,index) in data.details" :key="index">
                  <img :src="item" alt="" style="width: 100%;">
              </div>
          </div>
      </div>
      <!--产品信息-->
      <div class="specification bg-white padding-30">
          <div class="margin-bottom-10">产品信息</div>
          <div class="flex-row product-group">
              <div class="item click-cursor" v-for="(item,index) in data.productList" :key="index" @click="goDetail(item.id)">
                  <div class="img">
                      <img :src="item.proavtor" alt="" style="width:100%;height:100%;">
                  </div>
                  <div class="text-one-line">{{item.productname}}</div>
                  <div class="color-666 font-size-24">{{item.brand}}</div>
              </div>
          </div>
      </div>
      <!--客服-->
      <!-- <service-btn/> -->
      <div class="padding-15 text-center font-size-24">
          技术支持：济南笛滴软件有限公司 <span class="color-primary" @click="openDia">联系微信</span>
      </div>
      <div class="text-center" v-if="!data.code"><span class="color-primary" @click="quit">退出登录</span></div>
      <!--联系我们微信弹窗-->
      <van-dialog
              v-model:show="data.show"
              title="联系我们"
              class="dialog"
              :close-on-click-overlay="true"
              :show-confirm-button="false"
              :show-cancel-button="false">
          <div class="padding-30 dialog-in">
              <div class="qr" v-for="(item,index) in data.qrList" :key="index">
                  <img :src="item.qrcodeurl" alt="" style="width:100%;height:100%;">
              </div>
          </div>
      </van-dialog>
      <!--提示获取地理位置弹窗-->
      <van-dialog
              v-model:show="data.addressShow"
              title="温馨提示"
              class="dialog"
              @confirm="getConfirm"
              @cancel="getCancel"
              :close-on-click-overlay="false"
              confirm-button-color="#2FC73E"
              confirm-button-text="确定"
              cancel-button-text="取消"
              :show-confirm-button="true"
              :show-cancel-button="true">
          <p class="padding-15-30 font-size-28">
              需获取您的位置信息，仅辅助确认产品真伪，使用后自动失效，不会窃取到您的任何隐私。
          </p>
      </van-dialog>
  </div>
</template>

<script lang="ts">
  import {
    ref,
    nextTick,
    reactive,
    getCurrentInstance,
    onBeforeMount,
    onMounted,
    defineComponent
  } from 'vue';
  import {
    useRouter
  } from 'vue-router';
  import common from '@/assets/ts/common';
  import {
    Toast
  } from 'vant';
  import wx from 'weixin-jsapi';
  import {C_URL} from '@/assets/ts/config';
  interface HomeConfig {
    show: boolean,
      bannerList: any[],
      productList: any[],
      funList: any[],
      js_code: String,
      detail: any,
      token: any,
      code: string,
      isShow: boolean,
      qrList: any[],
      adDetail: {},
      details: any[],
      addressShow: boolean,
      selectIndex: string,
      scan: boolean,
      isadddate: any,
      showCustomerBtn:boolean
  };
  export default defineComponent({
    setup() {
      const router = useRouter();
      const data = reactive < HomeConfig > ({
        selectIndex: "",
        details: [],
        addressShow: false,
        show: false,
        bannerList: [],
        productList: [],
        funList: [{
            text: '开发中',
            url: "/ExtendedWarranty",
            img: require("../assets/images/home/icon_home_yanbao.png")
          },
          {
            text: '激活',
            url: "/Activate",
            img: require("../assets/images/home/icon_shouye_jihuo.png")
          },
          {
            text: '查验',
            url: "/Check",
            img: require("../assets/images/home/icon_shouye_chayan.png")
          },
          {
            text: '奖券',
            url: "/Lotteries",
            img: require("../assets/images/home/icon_shouye_jiangquan.png")
          }
        ],
        js_code: '',
        detail: {},
        token: "",
        code: "",
        isShow: false,
        qrList: [],
        adDetail: {},
        scan: true,
        isadddate: "",
        showCustomerBtn:false
      });
      const {
        ctx
      }: any = getCurrentInstance();
      const getTime: any = common.getTime;
      const returnTime: any = common.getDateDiff;
      onBeforeMount(() => {
        judge();
        console.log(C_URL)
        if(C_URL=='https://aftooladmin.jnddsoft.cn/api'){
          data.showCustomerBtn = false
        }else if(C_URL=='https://zcqadmin.jnddsoft.cn/api'){
          data.showCustomerBtn = true
        }
      });
      onMounted(() => {
        getQr();
        getBanner();
        getAdDetail();
        getDataList();
      });
      const getAdDetail = () => {
        common.request("post", "/adproduct/getAdPicLinkList")
          .then((res: any) => {
            data.adDetail = res.data;
          })
      };
      //获取弹窗内的二维码
      const getQr = () => {
        common.request("get", "/adproduct/getAdQrcode")
          .then((res: any) => {
            data.qrList = res.data;
          })
      };
      const judge = () => {
        console.log(window.location)
        let url = window.location.href;
        if (url.split('?')[1]) {
          //此处说明是二维码扫码进入的
          if (common.getCodeId(url)) {
            //alert("二维码扫码进入");
            localStorage.setItem("code", common.getCodeId(url));
            data.code = common.getCodeId(url);
            getDetail();
          } else {
            //alert("微信返回code进入");
            //非二维码扫码进入
            if (getCode()) {
              if (common.getToken()) {
                data.isadddate = localStorage.getItem("isadddate");
                getWxMessage();
              } else {
                //alert("获取token");
                data.js_code = getCode();
                getToken();
              }
            }
          }
        } else {
          //alert("直接点连接进入的");
          if (!common.getToken()) {
            router.push("/login");
          } else {
            data.isadddate = localStorage.getItem("isadddate");
            data.token = common.getToken();
            data.isShow = true;
            getWxMessage();
          }
        }
      };
      //请求加密签名,要登录
      const getWxMessage = () => {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let obj = {
          url: window.location.href.split('#')[0]
        };
        common.request("post", "/user/getJsApi", obj)
          .then((res: any) => {
            Toast.clear();
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: 'wxffd7309385d2fc24', // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.noncestr, // 必填，生成签名的随机串
              signature: res.data.encry, // 必填，签名
              jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
            });
            wx.error(function() {
              Toast("签名校验失败");
              data.scan = false;
            });
          })
          .catch(() => {
            data.scan = false;
          })
      };
      //获取授权微信后的code,要登录
      const getCode = () => {
        let url = window.location.href;
        let arr = url.split("?");
        let arr1 = arr[1].split("&");
        let code = '';
        arr1.map((item: any, index: number) => {
          if (item.split("=")[0] == 'code') {
            code = item.split("=")[1];
          }
        });
        data.js_code = code;
        return code;
      };
      //微信授权后的token获取,要登录
      const getToken = (): void => {
        common.request('get', '/user/wechatLogin', {
            js_code: data.js_code
          })
          .then((res: any) => {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem("isadddate", res.data.isadddate);
            data.isadddate = res.data.isadddate;
            data.token = res.data.token;
            nextTick(() => {
              getWxMessage();
            })
          }).catch((err: any) => {
            router.push("/login");
          })
      };
      //点击功能区按钮触发
      const onFunction = (item: any, text: string): void => {
        data.selectIndex = text;
        if (text === "激活" || text === "查验") {
          if (text === "激活") {
            data.addressShow = true;
          } else {
            onScanCode(text);
          }
        } else if (text === '开发中') {
          if (data.isadddate == '1') {
            router.push(item.url);
          } else {
            Toast("没有权限！");
          }
        } else {
          if (item.url) {
            router.push(item.url);
          } else {
            window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4ODY2MDY1Nw==&scene=124#wechat_redirect";
          }
        }
        //router.push(item.url);
      };
      //二维码扫码
      const onScanCode = (state: string) => {
        if (!data.scan) {
          return Toast("调起扫码失败");
        }
        wx.ready(function() {
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function(res: any) {
              let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              // let code = common.getCodeId(result);
              // if(state === "激活"){
              //   router.push({
              //     name:"Activate",
              //     query:{
              //       code:code
              //     }
              //   });
              // }else{
              //   router.push({
              //     name:"Check",
              //     query:{
              //       code:code
              //     }
              //   });
              // }
            },
            error: function(err: any) {
              console.log(err);
            }
          });
        });
      };
      //获取产品详情
      const getDetail = (): void => {
        common.request("get", "/qrocde/getQrcodeInfo", {
            qrcodeid: data.code
          })
          .then((res: any) => {
            data.detail = res.data;
            data.details = common.getBanner(data.detail.detailsurl);
            data.detail.createtimes = data.detail.createtimes.split(" ")[0];
            data.detail.servendtime = data.detail.servendtime.split(" ")[0];
          })
      };
      //获取产品列表
      const getDataList = (): void => {
        common.request('post', '/adproduct/getProductAdListInfo')
          .then((res: any) => {
            data.productList = res.data;
          });
      };
      //获取banner列表
      const getBanner = (): void => {
        common.request("get", "/adproduct/getAdBannerListInfo")
          .then((res: any) => {
            data.bannerList = res.data;
          })
      };
      //跳转登录页面
      const toDealer = (): void => {
        console.log('跳转至经销商扫码')
        router.push('/Login');
      };
      const toCustomer = (): void => {
        console.log('跳转至客服扫码')
        router.push('/Customer');
      };
      //跳转详情页
      const goDetail = (id: any): void => {
        router.push({
          name: `ProductDetail`,
          query: {
            id: id
          }
        })
      };
      //退出登录
      const quit = () => {
        common.request("post", "/user/loginout", {
            token: common.getToken()
          })
          .then((res: any) => {
            router.push("/login");
            localStorage.removeItem("token");
          })
      };
      const openDia = () => {
        data.show = true;
      };
      const goHome = () => {
        window.location.href = "https://zcq.jnddsoft.cn/";
      };
      //取消获取地理位置
      const getCancel = () => {
        data.addressShow = false;
      };
      //确定获取地理位置
      const getConfirm = () => {
        data.addressShow = false;
        onScanCode(data.selectIndex);
      };
      return {
        getConfirm,
        getCancel,
        goHome,
        openDia,
        quit,
        onFunction,
        data,
        ctx,
        toDealer,
        toCustomer,
        goDetail,
        onScanCode,
        getTime,
        returnTime
      };
    }
  });
</script>

<style lang="scss" scoped>
  @import '../assets/scss/common.scss';
  .home {
    overflow-y: auto;
  }
  .van-swipe-item {
    height: 380px !important;
  }
  .swiper-img {
    width: 100%;
    height: 380px;
    border-radius: 16px;
    overflow: hidden;
  }
  .fun-btn {
    padding: 30px 20px;
    width: calc(100% - 60px);
    margin: 0 auto;
    .fun-item {
      width: 25%;
      align-items: center;
      >div {
        width: 90px;
        height: 90px;
      }
    }
  }
  .advertising {
    .ad-img {
      width: 100%;
      height: 219px;
      overflow: hidden;
    }
  }
  .product {
    .product-content {
      min-height: 140px;
    }
  }
  .avtor-img {
    width: 140px;
    height: 140px;
  }
  .login-btn {
    line-height: 92px;
    background: $primary-color;
    width: 95%;
    text-align: center;
    color: #fff;
    border-radius: 10px;
  }
  .dialog-in {
    height: 50vh;
    overflow-y: auto;
  }
</style>
